module.exports = __webpack_public_path__ + "img/logo1.3070b984.png";